// extracted by mini-css-extract-plugin
module.exports = {"block":"CardEfficiency_block__3Z72w","grey":"CardEfficiency_grey__2BQIS","textBlock":"CardEfficiency_textBlock__Y6Ogz","status":"CardEfficiency_status__19HAx"};